/* « De la chanson au parfum » : sur ordinateur, la section se fige et le défilement passe d'une étape à l'autre ; sur mobile, étapes empilées */
(function () {
  'use strict';
  function init(s) {
    if (!s || s.dataset.pret) return; s.dataset.pret = '1';
    const tabs = Array.prototype.slice.call(s.querySelectorAll('.ap-pistes [role="tab"]'));
    const rail = s.querySelector('[data-m="rail"]'), piste = s.querySelector('[data-m="piste"]');
    if (!tabs.length) return;
    const mq = window.matchMedia('(min-width:861px)');
    let k = 0;
    function montrer(n) {
      k = n;
      tabs.forEach(function (b, i) {
        const on = i === n, p = document.getElementById(b.getAttribute('aria-controls'));
        b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1;
        p.setAttribute('aria-hidden', String(mq.matches && !on)); p.inert = mq.matches && !on; p.classList.toggle('on', on);
      });
      piste.style.transform = mq.matches ? 'translateX(calc(' + (-n * 100) + '% - ' + n + ' * var(--g) * 2))' : '';
    }
    const pas = function () { return window.innerHeight * 0.8; };
    const hauteurTete = function () { const t = document.getElementById('tete'); return t ? t.offsetHeight : 0; };
    function defiler() {
      if (!mq.matches) return;
      const y = hauteurTete() - rail.getBoundingClientRect().top;
      const n = Math.max(0, Math.min(tabs.length - 1, Math.round(y / pas())));
      if (n !== k) montrer(n);
    }
    function mesurer() { rail.style.height = mq.matches ? (rail.firstElementChild.offsetHeight + pas() * (tabs.length - 1)) + 'px' : ''; defiler(); }
    function aller(n) {
      if (!mq.matches) { montrer(n); return; }
      window.scrollTo({ top: rail.getBoundingClientRect().top + window.scrollY - hauteurTete() + n * pas(), behavior: 'smooth' });
    }
    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () { aller(i); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { aller((i + 1) % tabs.length); tabs[(i + 1) % tabs.length].focus(); }
        if (e.key === 'ArrowLeft') { aller((i + tabs.length - 1) % tabs.length); tabs[(i + tabs.length - 1) % tabs.length].focus(); }
      });
    });
    window.addEventListener('scroll', defiler, { passive: true });
    window.addEventListener('resize', mesurer); window.addEventListener('load', mesurer);
    mq.addEventListener('change', function () { mesurer(); montrer(k); });
    mesurer(); montrer(0);
  }
  function tout(r) { (r || document).querySelectorAll('[data-methode]').forEach(init); }
  if (document.readyState !== 'loading') tout(); else document.addEventListener('DOMContentLoaded', function () { tout(); });
  document.addEventListener('shopify:section:load', function (e) { tout(e.target); });
})();
